import React from 'react';

interface Pillar {
  step: string;
  tag: string;
  title: string;
  desc: string;
}

const pillars: Pillar[] = [
  {
    step: '01',
    tag: 'Govern & Verify',
    title: 'Deterministic Guardrails Before Autonomy',
    desc: 'AST-level SELECT-only enforcement, dynamic pgvector schema retrieval across 400+ tables, Keycloak RBAC, and human approval gates before executing queries on production data stores.'
  },
  {
    step: '02',
    tag: 'Automate & Optimize',
    title: 'Quantified Manual Hours Reclaimed',
    desc: 'Custom Python and Java automation engines triggered via GitLab CI/CD runners, masked encryption variables, and Google Workspace integrations — saving 250+ engineering hours every year.'
  },
  {
    step: '03',
    tag: 'Scale & Support',
    title: 'Production Reliability & AIOps Observability',
    desc: 'Deep roots supporting high-scale Kubernetes and Kafka workloads, Datadog/Loggly alerting, AWS cloud migrations, and AIOps automated incident creation for zero operational blind spots.'
  }
];

export default function Approach() {
  return (
    <section id="approach" className="approach-section">
      <div className="wrap">
        <div className="eyebrow">Engineering Philosophy</div>
        <h2 className="sectitle">Govern it, Automate it, Support it</h2>
        <p className="secintro">
          Three foundational engineering principles guiding every system delivered — whether architecting an autonomous AI agent, a mission-critical financial reporting pipeline, or resolving production incidents.
        </p>
        <div className="pillars">
          {pillars.map(p => (
            <div className="pillar" key={p.tag}>
              <div className="pillar-top">
                <span className="pillar-num">{p.step}</span>
                <div className="ptag">{p.tag}</div>
              </div>
              <h3 className="pillar-title">{p.title}</h3>
              <p className="pillar-desc">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
